export default __webpack_public_path__ + "static/media/paperPlane.svg.b19f0875.svg";